import axios from "axios";

import { config } from "../../config";
import { LocalStorage } from "../../data/localstorage";
import moment from "moment";
import { User } from '@/entity/authentication/user';
import { QueryInfo } from '@/util';
import { updateUserFromAdmin } from '../../entity/authentication/profile';
import { Rate } from "@/entity/rate";


export interface CorpoateQuery {
    corporateName: string
    statuss: string
    effectiveFrom?: string
    effectiveTo?: string
}

export interface userQuery {
    emailOrMobile: string
    roleId: string
    effectiveFrom: string
    effectiveTo: string
    userName: string
    status: string
}

export interface tariffQuery {
    tariffCode: string
    rate: string
    tax: string
    effectiveFrom: string
    effectiveTo: string
    status: string
}

export interface userReportQuery {
    fromDate: string,
    toDate: string
}

export interface usageReportQuery {
    toDate: string
}

export class AdminService {

    async getCorporateStatus(): Promise<any> {
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId  + "/getCorporateStatus", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let corpoateStatus: any = response.data.data
        return Promise.resolve(corpoateStatus)
    }

    async addCorporate(corporateName: string, status: string): Promise<any> {
        
        let userId = localStorage.getItem("user.id")
        let response = await axios.post(config.api.host + "/v1/admin/" + userId  + "/addCorporate", {
            data: {
                corporateName: corporateName,
                status: status
            }
        },
        {
            headers: {
                Authorization: new LocalStorage().authToken
            } 
        });
        return response.data;
        
    }

    async updateCorporate(corporateName: string, status: string, corporateId: number): Promise<any> {
        let userId = localStorage.getItem("user.id")
        const response = await axios.put(
            config.api.host + "/v1/admin/" + userId  + "/saveCorporate", {
                data: {
                    corporateName: corporateName,
                    status: status,
                    corporateId: corporateId
                }
            },
            {
            headers: {
                Authorization: new LocalStorage().authToken
            }
            }
        );
        return response.data;
    }

    async getUserDetails(): Promise<any> {
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId  + "/getUserDetails", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let userDetails: any = response.data.data
        return Promise.resolve(userDetails)
    }

    // async updateNewUser(emailOrMobile: string, userName: string, roleId: number): Promise<any> {
    //     let userId = localStorage.getItem("user.id")
    //     const response = await axios.put(
    //         config.api.host + "/v1/admin/" + userId  + "/saveUser", {
    //             data: {
    //                 emailOrMobile: emailOrMobile,
    //                 userName: userName,
    //                 roleId: roleId
    //             }
    //         },
    //         {
    //         headers: {
    //             Authorization: new LocalStorage().authToken
    //         }
    //         }
    //     );
    //     return response.data;
    // }

    async corporateNameList(page: number, size: number,query: CorpoateQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size": size
        } 
        if(query) {
            if(query.corporateName) {
                queryInfo = {...queryInfo,
                    corporateName: query.corporateName
                }
            }

            if(query.statuss) {
                queryInfo = {...queryInfo,
                    status: query.statuss
                }
            }
        }
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/" + userId  + "/getCorporateList" +  new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let corpoateInfo: any = response.data
        return Promise.resolve(corpoateInfo)
    }

    async addNewUser(userName: string, emailOrMobile: string, roleId: number): Promise<any> {
        
            let userId = localStorage.getItem("user.id")
            let response = await axios.post(config.api.host + "/v1/admin/" + userId  + "/addNewUserByAdmin", {
                data: {
                    userName: userName,
                    emailOrMobile: emailOrMobile,
                    userRole: roleId
                },
            },
            {
                headers: {
                    Authorization: new LocalStorage().authToken
                } 
            });
            return response.data.data;
        
    }


    async userNameList(page: number, size: number, query: userQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size": size
        } 
        if(query) {
            if(query.emailOrMobile) {
                queryInfo = {...queryInfo,
                    emailOrMobile: query.emailOrMobile
                }
            }

            if(query.roleId) {
                queryInfo = {...queryInfo,
                    roleId: query.roleId
                }
            }

            if(query.effectiveFrom) {
                queryInfo = {...queryInfo,
                    effectiveFrom: query.effectiveFrom
                }
            }

            if(query.effectiveTo) {
                queryInfo = {...queryInfo,
                    effectiveTo: query.effectiveTo
                }
            }

            if(query.userName) {
                queryInfo = {...queryInfo,
                    userName: query.userName
                }
            }

            if(query.status) {
                queryInfo = {...queryInfo,
                    status: query.status
                }
            }
        }
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId  + "/userListForAdmin" +  new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let corpoateInfo: any = response.data.data
        return Promise.resolve(corpoateInfo)
    }

    async userRoles(type: string) {
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId + "/userRoles/"+type, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
         
        return response.data.data.details
    }

    async deleteUser(userId: Number): Promise<any> {
        let loginUserId = localStorage.getItem("user.id")
        const response = await axios.put(
            config.api.host + "/v1/admin/" + loginUserId  + "/deleteUser", {
                data: {
                    userId: userId,
                    
                }
            },
            {
            headers: {
                Authorization: new LocalStorage().authToken
            }
            }
        );
        return response.data;
    }

    async TariffList(page: number, size: number, query: tariffQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size": size
        } 
        if(query) {
            if(query.tariffCode) {
                queryInfo = {...queryInfo,
                    tariffCode: query.tariffCode
                }
            }

            if(query.rate) {
                queryInfo = {...queryInfo,
                    rate: query.rate
                }
            }

            if(query.tax) {
                queryInfo = {...queryInfo,
                    tax: query.tax
                }
            }

            if(query.effectiveFrom) {
                queryInfo = {...queryInfo,
                    effectiveFrom: query.effectiveFrom
                }
            }

            if(query.effectiveTo) {
                queryInfo = {...queryInfo,
                    effectiveTo: query.effectiveTo
                }
            }

            if(query.status) {
                queryInfo = {...queryInfo,
                    status: query.status
                }
            }
        }
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId  + "/tariffListForAdmin" +  new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let tariffInfo: any = response.data
        return Promise.resolve(tariffInfo)
    }

    async getTimeOfUnitOptions(): Promise<any> {
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId  + "/timeOfUnitOptions", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let timeOfUnit: any = response.data.data
        return Promise.resolve(timeOfUnit.timeOfUnitOption)
    }

    async getZeroTariffOption(): Promise<any> {
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId  + "/zeroTariffOption", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let zeroTariff: any = response.data.data
        return Promise.resolve(zeroTariff.timeOfUnitOption)
    }

    async getTimeOfDayOptions(): Promise<any> {
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId  + "/timeOfDayOption", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let timeOfDay: any = response.data.data
        return Promise.resolve(timeOfDay.timeOfUnitOption)
    }

    async updateTaiff(payload: any): Promise<any> {
        let userId = localStorage.getItem("user.id")
        const response = await axios.put(
            config.api.host + "/v1/admin/" + userId  + "/saveTariffDetail", {data: payload},{
            headers: {
                Authorization: new LocalStorage().authToken
            }
            }
        );
        return response.data;
    }

    async addNewTariff(payload: any): Promise<any> {
        
            let userId = localStorage.getItem("user.id")
            let response = await axios.post(config.api.host + "/v1/admin/" + userId  + "/addTariffDetail", {data: payload},
            {
                headers: {
                    Authorization: new LocalStorage().authToken
                } 
            });
            return response.data;
        
    }

    async customerReport(query: userReportQuery): Promise<any> {
        let queryInfo: any = {}
        let userId = localStorage.getItem("user.id");

        if(query) {
            if(query.fromDate) {
                queryInfo = {... queryInfo,
                    fromDate: query.fromDate
                }
            }
            if(query.toDate) {
                queryInfo = {... queryInfo,
                    toDate: query.toDate
                }
            }
        }

        const response = await axios.get(
            config.api.host + "/v1/admin/" + userId + "/customerReport" + new QueryInfo(queryInfo).toURLString(),
            {
                headers: {
                    Authorization: new LocalStorage().authToken
                }
            }
        );

        return response.data;
    }

    async invoiceReport(query: userReportQuery): Promise<any> {
        let queryInfo: any = {}
        let userId = localStorage.getItem("user.id");

        if(query) {
            if(query.fromDate) {
                queryInfo = {... queryInfo,
                    fromDate: query.fromDate
                }
            }
            if(query.toDate) {
                queryInfo = {... queryInfo,
                    toDate: query.toDate
                }
            }
        }

        const response = await axios.get(
            config.api.host + "/v1/admin/" + userId + "/invoiceReport" + new QueryInfo(queryInfo).toURLString(),
            {
                headers: {
                    Authorization: new LocalStorage().authToken
                }
            }
        );

        return response.data;
    }

    async usageReport(query: usageReportQuery): Promise<any> {
        let queryInfo: any = {}
        let userId = localStorage.getItem("user.id");

        if(query) {
            if(query.toDate) {
                queryInfo = {... queryInfo,
                    toDate: query.toDate
                }
            }
        }

        const response = await axios.get(
            config.api.host + "/v1/admin/" + userId + "/usageReport" + new QueryInfo(queryInfo).toURLString(),
            {
                headers: {
                    Authorization: new LocalStorage().authToken
                }
            }
        );

        return response.data;
    }
}



    
